const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- ui-select ---
let __fez_component_0;
{

__fez_component_0 = class {
  PROPS = {
    name: String,
    label: String,
    options: Array,
    value: String,
    hint: String,
    error: String,
    disabled: Boolean,
  }

  onMount() {
    this.apply()
  }

  // After every render: a re-rendered option list would otherwise drop the selection.
  afterRender() {
    this.apply()
  }

  // A new `value` from the parent selects it; otherwise the last pick stays, also across renders.
  apply() {
    const select = this.state.select
    if (!select) return
    if (this.props.value !== undefined && this.props.value !== this.state.applied) {
      this.state.applied = this.props.value
      this.state.current = this.props.value
    }
    if (this.state.current !== undefined) select.value = this.state.current
    select.disabled = this.props.disabled
  }

  picked(value) {
    this.state.current = value
  }

  value() {
    return this.state.select?.value ?? ''
  }

  CSS = `:fez {
display:block;label{display:grid;gap:6px}.label{font-size:var(--text-sm);font-weight:var(--weight-semibold)}.control{position:relative;display:flex;align-items:center;.ui-icon-fez{position:absolute;right:var(--space-3);pointer-events:none;color:var(--color-text-subtle)}}select{appearance:none;width:100%;height:38px;padding:0 var(--space-8) 0 var(--space-3);border:1px solid var(--color-border-strong);border-radius:var(--radius-md);background:var(--color-bg-raised);color:var(--color-text);font-size:var(--text-md);cursor:pointer;&:focus{outline:0;border-color:var(--color-accent);box-shadow:0 0 0 3px var(--color-accent-soft)}&:disabled{color:var(--color-text-muted);background:var(--color-bg-subtle);cursor:default}}.hint,.error{font-size:var(--text-xs);color:var(--color-text-muted)}.error{color:var(--color-danger)}
}`

  HTML = `<label>
{#if props.label}
<span class="label">{props.label}</span>
{/if}
<span class="control">
<select fez:this="select" name={props.name} data-value={props.value} onchange="fez.picked(this.value)">
{#each props.options as option}
<option value={option.value}>{option.label}</option>
{/each}
</select>
<ui-icon name="caret-down" size="14"></ui-icon>
</span>
{#if props.error}
<span class="error" role="alert">{props.error}</span>
{:else if props.hint}
<span class="hint">{props.hint}</span>
{/if}
</label>`
};
}

Fez('ui-select', __fez_component_0);

export default __fez_component_0;
